/* istanbul ignore file*/
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { INotFoundModal } from '../../../../model/sitefinity/LoginPage';
import { ModalWindowComponent } from '../../../../shared/components/modal-window/modal-window.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { AriaLabelDirective } from 'src/app/shared';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'pgh-failed-login-modal',
    templateUrl: './failed-login-modal.component.html',
    imports: [
    ModalWindowComponent,
    MatIconButton,
    AriaLabelDirective,
    MatDialogClose,
    MatIcon,
    MatButton
]
})
export class FailedLoginModalComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;
  @Input() btnLbl: string;

  constructor(public dialogRef: MatDialogRef<FailedLoginModalComponent>, @Inject(MAT_DIALOG_DATA) public data: INotFoundModal, private router: Router) {
  }

  ngOnInit(): void {
    this.title = this.data.Title;
    this.content = this.data.Content;
    this.btnLbl = this.data.ButtonLabel;
  }

  onSignupClicked() {
    this.router.navigate(['/signup'], { queryParamsHandling: 'preserve' });
    this.dialogRef.close();
  }
}
